import { render, staticRenderFns } from "./SocialMediaLinkButton.vue?vue&type=template&id=49313a32&"
import script from "./SocialMediaLinkButton.vue?vue&type=script&lang=ts&"
export * from "./SocialMediaLinkButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports